import React from "react";
import "./AddInline.css";

interface Props {
  label: string;
  placeholder: string;
  /** Tighter indent + type for the nested (level) add. */
  small?: boolean;
  onAdd: (value: string) => void;
}

/** A dashed "+ Add …" affordance that swaps to an inline text box; Enter or
 *  blur-with-text commits the new name, Escape cancels. */
const AddInline: React.FC<Props> = ({ label, placeholder, small, onAdd }) => {
  const [open, setOpen] = React.useState(false);
  const [text, setText] = React.useState("");

  const commit = () => {
    const v = text.trim();
    if (v) onAdd(v);
    setText("");
    setOpen(false);
  };

  if (!open) {
    return (
      <button
        type="button"
        className={`takt-editor-add-btn ${small ? "is-small" : ""}`}
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        {label}
      </button>
    );
  }

  return (
    <input
      autoFocus
      className={`takt-editor-add-input ${small ? "is-small" : ""}`}
      value={text}
      placeholder={placeholder}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => setText(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === "Enter") commit();
        else if (e.key === "Escape") {
          setText("");
          setOpen(false);
        }
      }}
    />
  );
};

export default AddInline;
